<template>
  <div
    class="page-header p-d-flex p-ai-center p-jc-between p-flex-wrap"
    :class="{ 'tab-gradient-border': showBorder }"
  >
    <h3 class="p-my-0 p-mr-auto text-text-primary">
      {{ title }}<span v-if="subtitle" class="p-ml-1"> - {{ subtitle }}</span>
      <slot name="isLocked"></slot>
    </h3>
    <slot />
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    title: String,
    subtitle: String,
    showBorder: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss">
.page-header {
  line-height: 1.33334;
  padding-bottom: var(--gutter);

  h4 span {
    color: var(--secondary-color-text-neutral-darker);
  }
}
</style>
